module.exports = __webpack_public_path__ + "static/img/share-bg.3372db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/share-bg.png
// module id = FGHJ
// module chunks = 1